// extracted by mini-css-extract-plugin
module.exports = {"list":"_2NKtyM2fniKkvq6q0pT2d2"};